import { Component, OnInit, Inject } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { MsalService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { InteractionType} from '@azure/msal-browser';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  username : any;

  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
  private authService: MsalService,
  private _appService : AppService,) { }

  ngOnInit(): void {
    this._appService.getUsername().subscribe(username => this.username = username);
  }
  logout() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      this.authService.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/"
      });
    } else {
      this.authService.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }
  }
  addActiveClicked():any{
    document.getElementById('helpDropdownLink')?.classList.add('active');
  }
  removeActiveClass(){
    document.getElementById('helpDropdownLink')?.classList.remove('active');
  }

}
